import RemoteAssistance from "./RemoteAssistance";

export default RemoteAssistance;